export default (build) =>
  build.query({
    query: ({ uid }) => ({
      url: `/users/${uid}`,
      method: "GET",
    }),
    providesTags: (result, error, uid) => [{ type: "User", id: uid }],
  });
